import Endpoints from 'constants/Endpoints';
import {clearResource, setResource, setSaveStatusClosed, setSaveStatusDialog, setSaveStatusLoading} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestDELETE, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import validateSection from './helpers/validateSection';
import {DemandValidation} from 'constants/DemandValidation';
import objectExtension from 'libs/objectExtension';

const GUARANTEE_LIST_RESOURCE_ID = 'guaranteeList';

const get = async (id) => {
	try {
		const res = await RestRequestGET(Endpoints.GUARANTEE(id))
		reduxStore.dispatch(setResource(GUARANTEE_LIST_RESOURCE_ID, res))
	} catch (error) {
	}
}

const _save = async (url, values, force = false) => {
	const data = values;

	const { resources } = reduxStore.getState()
	const { guaranteeList } = resources;
	const diff = objectExtension.diff(data, guaranteeList);
	if (!force && diff === null) return null;

	try {
		return await RestRequestPOST(url, data)
	} catch (error) {
		throw error;
	}
}

const save = async (id, values) => {
	reduxStore.dispatch(setSaveStatusLoading())
	try {
		const res = await _save(Endpoints.GUARANTEE(id), values, true)
		if (res.success) {
			reduxStore.dispatch(setSaveStatusDialog())
			if (res !== null) {
				await validateSection(DemandValidation.GUARANTEE, id);
				await validateSection(DemandValidation.NATIONAL_NOTICE, id, false);
			}
		}else {
			reduxStore.dispatch(setSaveStatusClosed())
		}
		return res;
	} catch (error) {
	}
}

const validate = async (id) => {
	return RestRequestGET(Endpoints.GUARANTEE_VALIDATE(id))
}

const checkForDraft = async (id) => {
	return await RestRequestGET(Endpoints.GUARANTEE_AUTOSAVE_CHECK(id));
}

const loadDraft = async (id) => {
	const res = await RestRequestGET(Endpoints.GUARANTEE_AUTOSAVE(id));
	reduxStore.dispatch(setResource(GUARANTEE_LIST_RESOURCE_ID, res.result));
	return res;
}

const saveDraft = async (id, formValues) => {
	await RestRequestPOST(Endpoints.GUARANTEE_AUTOSAVE(id), formValues);
}

const deleteDraft = async (id) => {
	await RestRequestDELETE(Endpoints.GUARANTEE_AUTOSAVE(id));
}

const clearGuaranteeList = () => {
	reduxStore.dispatch(clearResource(GUARANTEE_LIST_RESOURCE_ID));
}

export default {
	GUARANTEE_LIST_RESOURCE_ID,
	clearGuaranteeList,
	get,
	save,
	validate,
	checkForDraft,
	loadDraft,
	saveDraft,
	deleteDraft
}
